var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['icon', _vm.size]},[_c(_vm.mySvg,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }